import { GradientText } from '@/src/common/components/marketing/heros/StyledComponents'
import { styled } from '@/src/stitches.config'
import { TPartnerPayload } from '@/src/modules/partners/types'
import convertDecimalToNumber from '@/src/common/utilities/convert/convertDecimalToNumber'

const StyledText = styled('p', {
    fontWeight: 'bold',
    my: 10,
    variants: {
        size: {
            sm: {
                fontSize: '1rem',
            },
            md: {
                fontSize: '1.5rem',
            },
            lg: {
                fontSize: '1.5rem',
                '@sm': {
                    fontSize: '1.75rem',
                },
                '@md': {
                    fontSize: '2rem',
                },
            },
            xl: {
                fontSize: '1.5rem',
                '@sm': {
                    fontSize: '2rem',
                },
                '@md': {
                    fontSize: '2.5rem',
                },
            },
        },
    },
    defaultVariant: {
        size: 'sm',
    },
})

type TDiscountProps = {
    partnerData: TPartnerPayload
    size?: 'sm' | 'md' | 'lg' | 'xl'
}

function buildIncentiveText(partnerData: TPartnerPayload): {
    gradientText: string
    regularText: string
} {
    const { isLoyaltyProgram, brandIncentive = 0 } = partnerData
    const { number: incentiveAsNumber, multipliedBy100: incentiveTimes100 } =
        convertDecimalToNumber(brandIncentive, true)

    if (isLoyaltyProgram) {
        const { loyaltyUnit, loyaltyConversionRate = 100 } = partnerData

        const adjustedIncentiveRate: number =
            incentiveAsNumber * (loyaltyConversionRate / 100)
        const adjustedUnit: string =
            adjustedIncentiveRate > 1 ? loyaltyUnit : loyaltyUnit.split('s')[0]

        return {
            gradientText: `Earn ${adjustedIncentiveRate} ${adjustedUnit}`,
            regularText: 'per $ spent',
        }
    }

    // using times 100 to represent % as whole number
    return {
        gradientText: `${incentiveTimes100}% OFF`,
        regularText: 'Discount',
    }
}

const DiscountText = ({ partnerData, size }: TDiscountProps) => {
    const { gradientText, regularText } = buildIncentiveText(partnerData)

    return (
        <StyledText size={size}>
            <GradientText>{gradientText}</GradientText> {regularText}
        </StyledText>
    )
}

export default DiscountText
